import Sidebar from "../components/sidebar/side"
import Leadboxes from "../components/leadboxes/leadbox";
import Leadstatus from "../components/leadstatus/leadstatus";
function Leadreport(){
    return(
        <>
           <Sidebar/>
        <Leadboxes/>
        <Leadstatus/>
        </>
    )
}
export default Leadreport